import * as nprogress from 'nprogress';
import 'jquery-ui/ui/widgets/autocomplete';
import filter from 'lodash/filter';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import EventDispatcher from 'events';

export default class SalePoint extends EventDispatcher {
    constructor(selector) {
        super();

        this.widget = $(selector ? selector : '.aside.aside_right');
        this.points = [];
        this.cachedPoints = {};
        this.activePointId = null;

        if (this.widget.length === 0) {
            throw new Error('Не найден aside виджет');
        }

        this.init();
    }

    init() {
        $(this.widget).on('click', '.aside__place', (e) => {
            this.showPoint($(e.currentTarget).data('id'), $(e.currentTarget).data('path'));
        });

        this.widget.find('.aside__place').each((index, element) => {
            this.points.push({
                id: $(element).data('id'),
                path: $(element).data('path'),
                schemaId: $(element).data('schema-id')
            });
        });

        $.fn.extend({
            toggleText: function (a, b) {
                return this.text(this.text() == b ? a : b);
            }
        });

        if ($(window).width() <= 1023) {
            this.widget.find('.aside__name').off().click(function () {
                $('.aside_right').toggleClass('aside_right_full');
                $('.aside_right').find('.aside__name').toggleText('Назад', 'Список точек');
                $('.aside_right').find('.aside__scroll').toggleClass('aside__scroll_show');
                $('.aside__btn').removeClass('aside__btn_active');
            });
        }

        $('.aside__btn').click(function () {
            $(this).toggleClass('aside__btn_active');
        });

        $('.aside__btn_second').click(function () {
            $('.aside_left').removeClass('aside_left_show');
            $('.aside_right').toggleClass('aside_right_full');
            $('.aside_right').find('.aside__scroll').toggleClass('aside__scroll_show');
            $('.aside_right').find('.aside__name').text('Назад');
            $('.aside__scroll').addClass('aside__scroll_show');
            $(this).addClass('aside__btn_active');
            $('.aside__btn_first').removeClass('aside__btn_active');
        });

        $('.aside__btn_first').click(function () {
            $('.aside_right').removeClass('aside_right_full');
            $('.aside_right').find('.aside__scroll').removeClass('aside__scroll_show');
            $('.aside_left').toggleClass('aside_left_show');
            $(this).addClass('aside__btn_active');
            $('.aside__btn_second').removeClass('aside__btn_active');

        });

        this.widget.find('.aside__back').off().click(() => {
            this.hidePoint();
            
        });

        this.initSearch();
    }

    initSearch() {
        let searchIcon = $('.js_sale-point_search-icon');

        $('.js_sale-point_search-input').keypress(function (e) {
            if (e.which == 13) {
                searchIcon.click();
            }
        });

        $(".js_sale-point_search-input").autocomplete({
            minLength: 0,
            source: function(request, response) {
                $.ajax({
                    method: 'GET',
                    url: '/ajax/search-map',
                    data: {
                        term: request['term']
                    },
                    success: (r) => {
                        // let items = r;
                        // let matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), 'i');
                        // let results = filter(items, function(item) {
                        //     return matcher.test(item.label) || (item.add && matcher.test(item.add));
                        // });
                        // map(results, function(result){
                        //     return result.index = result.label.indexOf(request.term);
                        // });
                        // results = sortBy(results, [function(result) { return result.index; }]);
                        // response(results);
                        response(r);
                    }
                });
            },
            appendTo: '.js_sale-point_search-bar',
            blankItem: true,
            select: (event, ui) => {
                $(".js_sale-point_search-input").val(ui.item.label);
                let id = ui.item.id.split("_");
                switch(id[0]) {
                    case 'category':
                        this.changePointsContent({
                            'category': id[1]
                        });
                        break;
                    case 'point':
                        if(find(this.points, {id: parseInt(id[1])}) === undefined) {
                            this.points.push({
                                id: parseInt(id[1]),
                                path: ui.item['path_data'],
                                schemaId: ui.item['schema_id']
                            });
                        }
                        this.showPoint(find(this.points, {id: parseInt(id[1])}));
                        break;
                    case 'supplier':
                        this.changePointsContent({
                            'supplier': id[1]
                        });
                        break;
                }

                searchIcon.addClass('search__icon_clear');

                return false;
            }
        }).autocomplete('instance')._renderItem = function(ul, item) {
            return $("<li id='"+ item.id +"' class='ui-menu-item'>")
                .append(
                    (item.color ? '<div class="ui-menu-item-color" style="background-color: '+
                        item.color +
                        '"></div>' : '')
                    + item.label + (item.add && item.add.length !== 0 ? " <small style='color: grey; font-size: 0.8rem'>"+ item.add +"</small>" : '')
                    + "</div>")
                .appendTo(ul);
        };

        searchIcon.click(() => {
            if (searchIcon.hasClass('search__icon_clear')) {
                $(".js_sale-point_search-input").val('');
                searchIcon.removeClass('search__icon_clear');
                this.changePointsContent('')
            }
        });
    }

    showPoint(id) {
        let _this = this;
        let cacheId;

        if(typeof id == 'object') {
            cacheId = id.id;
        } else {
            cacheId = id;
        }

        function open(id) {

            let cacheId;

            if(typeof id == 'object') {
                cacheId = id.id;
            } else {
                cacheId = id;
            }

            $('.aside__rails').addClass('aside__rails_hidden');
            $('.aside_right').addClass('aside_right_full');
            $('.aside__more').addClass('aside__more_show');
            $('.shop').addClass('shop_show');
            _this.activePointId = cacheId;
            if (_this.cachedPoints[cacheId]) {
                _this.widget.find('.shop__content').html(_this.cachedPoints[cacheId]);
            }
            if(typeof id == 'number') {
                _this.emit('select', find(_this.points, {id: id}))
            } else {
                _this.emit('select', id);
            }
        }

        if (this.cachedPoints[cacheId]) {
            open(id);
        } else {
            nprogress.start();
            $.post({
                url: '/ajax/point-show',
                data: {
                    id: id
                }
            }).done((response) => {
                if (response['html']) {
                    let block = $(response.html).find('.shop__content').html();
                    this.widget.find('.shop__content').html(block);
                    this.cachedPoints[cacheId] = block;
                    open(id);
                }
            }).fail((error) => {
                console.error(error);
            }).always(() => {
                nprogress.done();
            });
        }
    }

    hidePoint() {
        if (!this.activePointId) {
            return;
        }
        $('.aside__rails').removeClass('aside__rails_hidden');
        $('.aside_right').removeClass('aside_right_full');
        $('.aside__more').removeClass('aside__more_show');
        if(typeof this.activePointId == 'number') {
            this.emit('unSelect', find(this.points, {id: this.activePointId}))
        } else {
            this.emit('unSelect', this.activePointId);
        }
        $('.aside__btn').removeClass('aside__btn_active');
        this.emit('unSelect', this.activePointId);
        this.activePointId = null;
    }

    changePointsContent(params) {
        if (this.widget) {
            nprogress.start();
            $.post({
                url: '/ajax/points',
                data: params
            }).done((response) => {
                this.widget.find('.aside__rails').html($(response['html']).html());
                this.points = [];
                $(response['html']).find('.aside__place').each((index, element) => {
                    this.points.push({
                        id: $(element).data('id'),
                        path: $(element).data('path'),
                        schemaId: $(element).data('schema-id')
                    });
                });
                this.emit('change', this.points);
                if(this.points.length === 1) {
                    this.showPoint(this.points[0].id);
                } else {
                    this.hidePoint()
                }
            }).fail((error) => {
                console.error(error);
            }).always((response) => {
                nprogress.done();
            })
        }
    }
}



// WEBPACK FOOTER //
// app/widgets/assets/sale-point/widget.js